import { SxProps, Theme } from '@mui/material';

export const getHeroReviewsCardContainerStyles = (theme: Theme): SxProps => ({
	width: '100%',
	borderRadius: '1rem',
	minHeight: '14.25rem',
	maxHeight: '31.875rem',
	backgroundColor: 'common.white',
	color: 'common.black',
	display: 'flex',
	flexDirection: 'column',
	[theme.breakpoints.down('lg')]: {
		minHeight: '20.5rem',
	},
	[theme.breakpoints.down('md')]: {
		height: '14.25rem',
	},
});

export const heroReviewsCardContent: SxProps = {
	padding: '1rem',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-around',
	flex: 1,
	minHeight: 0,
};

export const ratingHeader: SxProps = {
	display: 'flex',
	width: '100%',
	alignItems: 'center',
	justifyContent: 'space-between',
};

export const ratingStars: SxProps = {
	display: 'flex',
	alignItems: 'center',
	gap: '0.25rem',
};

export const reviewCommentBox: SxProps = {
	height: 'calc(100% - 115px)',
	paddingTop: '0.5rem',
	display: 'grid',
	gridAutoFlow: 'column',
	gridAutoColumns: '100%',
	overflowX: 'auto',
	scrollSnapType: 'x mandatory',
	gap: 0,
	scrollbarWidth: 'none',
};

export const controlsRow: SxProps = {
	display: 'flex',
	alignItems: 'center',
	gap: '0.75rem',
};

export const arrowBtn: SxProps = {
	padding: 0,
	minWidth: 'auto',
	'&:disabled': {
		color: 'var(--mui-palette-neutral1-dark)',
		cursor: 'default',
	},
	'&:disabled svg': {
		color: 'inherit',
	},
};

export const dotsRow: SxProps = {
	display: 'inline-flex',
	alignItems: 'center',
	gap: '0.375rem',
};

const dotBase = {
	appearance: 'none',
	border: 'none',
	padding: 0,
	margin: 0,
	display: 'inline-block',
	width: '8px',
	height: '8px',
	borderRadius: '9999px',
	backgroundColor: '#c9ced6',
	cursor: 'pointer',
	transition: 'width 150ms ease, height 150ms ease, background-color 150ms ease',
};

export const getDotStyles = (theme: Theme): SxProps => ({
	...dotBase,
	[theme.breakpoints.down('md')]: {
		width: '10px',
		height: '10px',
	},
});

export const dotActiveStyles: SxProps = {
	...dotBase,
	backgroundColor: 'common.black',
	width: '33px',
	height: '6px',
};

export const getTruncateTextStyles = (theme: Theme): SxProps => ({
	scrollSnapAlign: 'start',
	[theme.breakpoints.up('lg')]: {
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		lineClamp: 2,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});
